// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/uScope/js/extensions/image-toolbar/image-toolbar.scss
// module id = 421
// module chunks = 0